import React, { useState } from "react";
import fileUpload from "assets/images/fileUpload.svg";
import fileCompleted from "assets/images/fileCompleted.svg";
import removeImg from "assets/svgs/close.svg";
import server from "api/server";
import { handleImage } from "helpers/functions";

const PdfUpload = ({
  selectedPdfFile,
  setSelectedPdfFile,
  accept = "pdf/*",
  className = "",
}) => {
  const [uploadProgress, setUploadProgress] = useState(0); // Track upload progress
  const [isUploading, setIsUploading] = useState(false); // Track upload state

  const pdfChange = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setIsUploading(true); // Set uploading to true
      const formData = new FormData();
      formData.append("file", e.target.files[0]);

      try {
        const { data } = await server().post("/upload", formData, {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percentCompleted); // Update progress
          },
        });

        setSelectedPdfFile({
          preview: e.target.files[0],
          path: data?.data?.file.fullpath,
        });
      } catch (error) {
        console.error("Upload error", error);
      } finally {
        setIsUploading(false); // Reset uploading state
        setUploadProgress(0); // Reset progress
      }
    }
  };

  const removeSelectedPdfFile = () => {
    setSelectedPdfFile(""); // Reset the pdfFile state as well
  };

  return (
    <div className={`image-uploader image-contain ${className}`}>
      <div className="img-pat">
        {isUploading ? (
          <div className="progress-indicator">
            <span>{uploadProgress}%</span>
          </div>
        ) : (
          <img
            src={fileUpload}
            width={50}
            height={50}
            alt=""
            className="filePdfIcon"
          />
        )}
      </div>
      <label>
        {(selectedPdfFile?.preview || selectedPdfFile?.path) && (
          <div className="filePdfIconDiv">
            <MediaShow
              selectedPdfFile={
                handleImage(selectedPdfFile?.path) || selectedPdfFile?.preview
              }
            />

            <button className="removeImg" onClick={removeSelectedPdfFile}>
              <img src={removeImg} alt="" />
            </button>
          </div>
        )}
        <input accept="pdf/*" type="file" onChange={pdfChange} />
      </label>
    </div>
  );
};

export const MediaShow = ({ selectedPdfFile, style }) => (
  <img
    src={
      selectedPdfFile && selectedPdfFile.preview
        ? URL.createObjectURL(selectedPdfFile.preview)
        : fileCompleted
    }
    width={200}
    height={140}
    style={style}
    alt=""
    className="filePdfIcon"
  />
);

export default PdfUpload;
